export default class NFFomErrorValidation {
	start() {
		if ($('.ENABLE_NF_FORM_ERROR_VALIDATION_A11Y_ISSUE_FIX').length === 0) {
			return;
		}
		this.nfFomErrorValidation();
	}

	nfFomErrorValidation() {
		$(document).on('nfFormReady', () => {
			$('.nf-form-fields-required').attr('aria-hidden', 'true');
			const nfCustomFieldController = Marionette.Object.extend({
				initialize() {
					const fieldsChannel = Backbone.Radio.channel('fields');
					const emailChannel = Backbone.Radio.channel('email');
					const submitChannel =  Backbone.Radio.channel('submit');
					emailChannel.off('blur:field');
					emailChannel.off('keyup:field');
					emailChannel.off('change:field');
					emailChannel.off('change:modelValue');
					fieldsChannel.off('change:field');
					fieldsChannel.off('blur:field');
					fieldsChannel.off('keyup:field');
					fieldsChannel.off('change:modelValue');
					this.listenTo(submitChannel, 'validate:field', this.requiredFieldValidation);
					this.listenTo(submitChannel, 'validate:field', this.focusFirstInvalidInput);
					submitChannel.reply('focus:getFirstInvalidInput', this.getFirstInvalidInput);
					nfRadio.channel('fields').reply('get:getFirstFieldByElementId', this.getFirstFieldByElementId);
				},
				//Focus first invalid element
				focusFirstInvalidInput: (e) => {
					const i = nfRadio.channel('app').request('get:form', e.get('formID'));
					const fieldsError = i.get('fieldErrors');
					if (_.size(fieldsError) > 0) {
						const fieldType = e.get('type');
						nfRadio.channel('submit').request('focus:getFirstInvalidInput', Object.keys(i.get('fieldErrors')), fieldType);
					}
				},

				getFirstInvalidInput: (e, fieldType) => {
					const t = nfRadio.channel('fields').request('get:getFirstFieldByElementId', e);
					switch (fieldType) {
					case 'listradio':
					case 'listmultiselect':
					case 'listcheckbox': {
						if (document.getElementById(`nf-field-${t}-0`) !== null) {
							document.getElementById(`nf-field-${t}-0`).focus();
						}
						break;
					}
					case 'date': {
						if (document.getElementById(`nf-field-${t}`) !== null) {
							jQuery(`#nf-field-${t}`).parent().find("input[type='text']").focus();
						}
						break;
					}
					default: {
						if (document.getElementById(`nf-field-${t}`) !== null) {
							document.getElementById(`nf-field-${t}`).focus();
						}
					}
					}
				},

				getFirstFieldByElementId: (idsArray) => {
					let targetID = 0;
					//Loop through an array of fieldIDs to return the one that is positioned first
					_.each(idsArray, (id) => {
						//Get field order
						const order = nfRadio.channel('fields').request('get:field', id);
						//Set it as the target when the lowest order is found
						targetID = (targetID === 0 || order < targetID) ? id : targetID;
					});
					return targetID;
				},

				//function for handle custom error message
				requiredFieldValidation: (model) => {
					if (model.get('required') !== 1 || !model.get('visible') || model.get('clean')) return;
					const type = model.get('type');
					const modelId             = model.get('id');
					const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					const getCurrentField = nfRadio.channel('fields').request('get:field', modelId);
					const getCurrentForm = nfRadio.channel('app').request('get:form', getCurrentField.get('formID'));
					const fieldsChannel = Backbone.Radio.channel('fields');
					const requiredErrorId = 'required-error';
					const adminLabel = model.get('admin_label');
					const checkboxValue     = model.get('value');
					const checkboxErrorId       = 'custom-checkbox-field-error';
					switch (type) {
					case 'email': {
						const emailCustomErrorMessage = getCurrentForm.get('settings').changeEmailErrorMsg;
						const errorId = 'custom-email-field-error';
						const emailValue = model.get('value');
						if (emailRegex.test(emailValue)) {
							fieldsChannel.request('remove:error', modelId, errorId);
						} else {
							fieldsChannel.request('remove:error', modelId, requiredErrorId);
							fieldsChannel.request('add:error', modelId, errorId, emailCustomErrorMessage);
						}
						break;
					}
					case 'checkbox': {
						if ((checkboxValue === 0) && (adminLabel === 'readDisclaimer')) {
							const checkboxCustomErrorMessage = (getCurrentForm.get('settings').disclaimerCheckBoxErrorMsg) ? (getCurrentForm.get('settings').disclaimerCheckBoxErrorMsg) : 'Please indicate that you have read and agree to the Disclaimer.';
							fieldsChannel.request('remove:error', modelId, requiredErrorId);
							fieldsChannel.request('add:error', modelId, checkboxErrorId, checkboxCustomErrorMessage);
						} else {
							fieldsChannel.request('remove:error', modelId, checkboxErrorId);
						}
						if ((checkboxValue === 1) && (adminLabel !== 'readDisclaimer')) {
							fieldsChannel.request('remove:error', modelId, requiredErrorId);
						}
						break;
					}
					default: {
						const currentValue = model.get('value');
						if (String(currentValue).trim()) {
							nfRadio.channel('fields').request('remove:error', modelId, requiredErrorId);
						} else {
							nfRadio.channel('fields').request('add:error', modelId, requiredErrorId, getCurrentForm.get('settings').validateRequiredField);
						}
					}
					}
				},
			});
			(() => new nfCustomFieldController())();
		});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/nf/controllers/nf_a11y_validation.js